import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.deleteTermOrMethod.presenters.useDeleteTermOrMethodPresenter`

export default defineMessages({
  confirmationModalTitle: {
    id: `${scope}.confirmationModalTitle`,
    defaultMessage: 'Delete item',
  },
  confirmationModalDescription: {
    id: `${scope}.confirmationModalDescription`,
    defaultMessage:
      'Would you like to delete {name}? This action cannot be undone.',
  },
  confirmationModalConfirmButton: {
    id: `${scope}.confirmationModalConfirmButton`,
    defaultMessage: 'Confirm',
  },
  confirmationModalCancelButton: {
    id: `${scope}.confirmationModalCancelButton`,
    defaultMessage: 'Cancel',
  },
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: '{name} has been deleted.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Error processing the request.',
  },
})
